export enum DashboardTaskKey {
  ANALYSE_CALLS = "analyse-calls",
  ENRICH_AVATAR = "enrich-avatar",
  STALE_CRITERIA = "stale-criteria",
  STALE_SEQUENCES = "stale-sequences",
  SCAN_IMPORTED_PROFILES = "scan-imported-profiles",
  UNTOUCHED_PROSPECTS = "untouched-prospects",
}

export type DashboardTask = {
  key: DashboardTaskKey;
  count: number;
};
